window.baseurl = 'http://192.168.0.228:210'
//window.baseurl = 'http://192.168.0.229:200'
//window.baseurl = 'http://192.168.0.229:210'
//window.baseurl = 'http://192.168.0.172:210'
//****************************获取cookie***************************//
window.getCookie = function(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if(arr = document.cookie.match(reg))
		return unescape(arr[2]);
	else
		return null;
}
//****************************写cookie***************************//
window.setCookie = function(name, value) {
	var Days = 30;
	var exp = new Date();
	exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
	document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

//****************************将毫秒数格式化输入***************************//
window.formatDate = function(time, format) {
	var t = new Date(time);
	var tf = function(i) {
		return(i < 10 ? '0' : '') + i
	};
	return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
		switch(a) {
			case 'yyyy':
				return tf(t.getFullYear());
				break;
			case 'MM':
				return tf(t.getMonth() + 1);
				break;
			case 'mm':
				return tf(t.getMinutes());
				break;
			case 'dd':
				return tf(t.getDate());
				break;
			case 'HH':
				return tf(t.getHours());
				break;
			case 'ss':
				return tf(t.getSeconds());
				break;
		}
	})
}

var now = new Date(); //当前日期
var nowDayOfWeek = now.getDay(); //今天本周的第几天
var nowDay = now.getDate(); //当前日
var nowDD = (nowDay < 10) ? ('0' + nowDay) : nowDay;
var nowMonth = now.getMonth(); //当前月
var nowmm = ((nowMonth + 1) < 10) ? ('0' + (nowMonth + 1)) : (nowMonth + 1);
var nowYear = now.getYear(); //当前年
nowYear += (nowYear < 2000) ? 1900 : 0; //
var nowHours = now.getHours();
var nowHH = (nowHours < 10) ? ('0' + nowHours) : nowHours;
var nowMinutes = now.getMinutes();
var nowMM = (nowMinutes < 10) ? ('0' + nowMinutes) : nowMinutes;
var nowSeconds = now.getSeconds();
var nowss = (nowSeconds < 10) ? ('0' + nowSeconds) : nowSeconds;
window.dtime = function(type) {
	return nowYear + type + nowmm + type + nowDD + " " + nowHH + ":" + nowMM + ":" + nowss;
}
//****************************获得本月天数 ***************************//
window.getMonthDays = function(myMonth) {
	var monthStartDate = new Date(nowYear, myMonth, 1);
	var monthEndDate = new Date(nowYear, myMonth + 1, 1);
	var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
	return days;
}
//****************************获得本月的开端日期 ***************************//
window.getMonthStartDate = function() {
	var monthStartDate = new Date(nowYear, nowMonth, 1);
	return formatDate(monthStartDate.getTime(), 'yyyy-MM-dd');
}

//****************************获得本月的停止日期 ***************************//
window.getMonthEndDate = function() {
	var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
	return formatDate(monthEndDate.getTime(), 'yyyy-MM-dd');
}

//正则验证
window.checkReg = function(type, no) {
	var pattern;
	switch(type) {
		case 'tel':
			pattern = /^1[345789]\d{9}$/;
			break;
		case 'mail':
			pattern = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
			break;
		case 'card':
			pattern = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/;
			break;
		case 'yzm':
			pattern = /^[a-z0-9]{4}$/;
			break;
		case 'psw':
			pattern = /(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9]{6,16})$/;
			break;
		case 'name':
			pattern = /^[\u4e00-\u9fa5]{2,15}$/;
			break;
		case 'quhao':
			pattern = /^0\d{2,3}$/;
			break;
		case 'guhua':
			pattern = /\d{7,8}/;
			break;
		case 'fenji':
			pattern = /\d{1,4}/;
			break;
		case 'sz': //数字
			pattern = /^(\d*\.)?\d+$/;
			break;
		case 'zzs': //正整数
			pattern = /^[0-9]*[1-9][0-9]*$/;
			break;
		case 'sfz': //身份证 输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。
			//          pattern = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
			pattern = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
			break;
	}
	if(pattern.test(no)) {
		return true;
	} else {
		return false;
	}
}

//*************************************生成随机数****************************//
var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

window.generateMixed = function(n) {
	var res = "";
	for(var i = 0; i < n; i++) {
		var id = Math.ceil(Math.random() * 35);
		res += chars[id];
	}
	return res;
}

//*************************************HTML转义****************************//

window.htmlencode = function(s) {
		var div = document.createElement('div');
		div.appendChild(document.createTextNode(s));
		return div.innerHTML;
	},
	window.htmldecode = function(s) {
		var div = document.createElement('div');
		div.innerHTML = s;
		return div.innerText || div.textContent;
	}

//*************************************时间计算****************************//

window.jisuanshijian = function(tiwen) {
	let now = new Date();
	let nowt = now.getTime();
	let oldt = new Date(tiwen);
	let shijiancha = (nowt - oldt.getTime()) / 1000;
	if(shijiancha < 60) {
		return '刚刚';
	} else if(shijiancha >= 60 && shijiancha < 3600) {
		return parseInt(shijiancha / 60) + '分钟前';
	} else if(shijiancha >= 3600 && shijiancha < (3600 * 24)) {
		return parseInt(shijiancha / 3600) + '小时前';
	} else if(shijiancha >= (3600 * 24) && shijiancha < (3600 * 24 * 100)) {
		return parseInt(shijiancha / (3600 * 24)) + '天前';
	} else if(shijiancha >= (3600 * 24 * 100)) {
		return '很久以前';
	}
}

//*************************************加号替换****************************//
window.JiahaoTihuan = function(str) {
	str = str.replace(/% 2B/g, '+');
	return str;
}
window.JiahaoFan = function(str) {
	str = str.replace(/\+/g, '% 2B');
	return str;
}

//*************************************返回 查询参数 url****************************//
window.Canshuurl = function(str) {
	let url = "/appsearch_diy.aspx?t=canshu&type=search_diy&sqlvalue=shanchuzhuangtai=0,classid=" + str + "&number=all&orderby=asc";
	return url;
}
window.CanshuurlID = function(str) {
	let url = "/appsearch_diy.aspx?t=canshu&type=search_diy&sqlvalue=shanchuzhuangtai=0,id=" + str;
	return url;
}
window.Canshuurl_biy = function(t, id_type, id, sczt_type) {
	let sczt = "";
	if(sczt_type == '0') {
		sczt = ",shanchuzhuangtai=0";
	}
	let url = "/appsearch_diy.aspx?t=" + t + "&type=search_diy&sqlvalue=" + id_type + "=" + id + sczt + "&number=all&orderby=asc";
	return url;
}
window.Canshuurl_ciy = function(t, sczt_type) {
	let sczt = "";
	if(sczt_type == '0') {
		sczt = "shanchuzhuangtai=0";
	}
	let url = "/appsearch_diy.aspx?t=" + t + "&type=search_diy&sqlvalue=" + sczt + "&number=all&orderby=asc";
	return url;
}
//*************************************数据格式输出****************************//
window.Json_ = function() {
	let all = arguments;
	for(let i in all) {
		//      console.log(JSON.stringify(all[i]));
	}
}
//*************************************标准时间格式 yyyy-MM-dd hh:mm:ss****************************//
window.bztime = function(myDate) {
	let bb = window.Panduanxx(myDate);
	if(bb == 'date') {

	} else {
		myDate = new Date(myDate);
	}
	let yyyy = myDate.getFullYear();
	let MM = myDate.getMonth() + 1;
	MM = (MM < 10) ? MM = '0' + MM : MM;
	let dd = myDate.getDate();
	dd = (dd < 10) ? dd = '0' + dd : dd;
	let hh = myDate.getHours();
	hh = (hh < 10) ? hh = '0' + hh : hh;
	let mm = myDate.getMinutes();
	mm = (mm < 10) ? mm = '0' + mm : mm;
	let ss = myDate.getSeconds();
	ss = (ss < 10) ? ss = '0' + ss : ss;
	return yyyy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss;
}

window.riqi = function(myDate, type) {
	let bb = window.Panduanxx(myDate);
	if(bb == 'date') {
		let yyyy = myDate.getFullYear();
		let MM = myDate.getMonth() + 1;
		MM = (MM < 10) ? MM = '0' + MM : MM;
		let dd = myDate.getDate();
		dd = (dd < 10) ? dd = '0' + dd : dd;
		let hh = myDate.getHours();
		hh = (hh < 10) ? hh = '0' + hh : hh;
		let mm = myDate.getMinutes();
		mm = (mm < 10) ? mm = '0' + mm : mm;
		let ss = myDate.getSeconds();
		ss = (ss < 10) ? ss = '0' + ss : ss;
		if(type == '0') {
			return yyyy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss;
		} else if(type == '1') {
			return yyyy + "-" + MM + "-" + dd;
		} else if(type == '2') {
			let c = [yyyy, MM, dd];
			return c;
		} else if(type == '3') {
			return yyyy + "/" + MM + "/" + dd;
		} else if(type == '4') {
			return yyyy + "/" + MM;
		}
	} else {
		return myDate;
	}
}
//*************************************提醒时间****************************//
window.txsj = function(str) {
	let stra = "";
	let strb = "";
	let tsa = new RegExp("分钟");
	let tsb = new RegExp("小时");
	let tsc = new RegExp("天");
	if(tsa.test(str)) {
		stra = str.replace(tsa, "");
		strb = "分";
	} else if(tsb.test(str)) {
		stra = str.replace(tsb, "");
		strb = "时";
	} else if(tsc.test(str)) {
		stra = str.replace(tsc, "");
		strb = "天";
	}
	let end = {
		stra: stra,
		strb: strb
	};
	return end;
}
//*************************************去除前后空格****************************//
window.quchukongge = function(str) {
	let cc = str.replace(/(^\s*)|(\s*$)/g, "");
	return cc;
}
//*************************************去除所有空格****************************//
window.allkong = function(str) {
	let cc = null;
	try {
		cc = str.replace(/\s+/g, "");
	} catch(e) {
		cc = str;
	}
	return cc;
}
//*************************************转码处理****************************//
window.zhuanma = function(str) {
	let cc = str.replace(/\+/g, '% 2B');
	cc = escape(cc);
	return cc;
}

//对象批量解码
window.jiema = function(obj) {
	for(let i = 0; i < obj.length; i++) {
		for(let j in obj[i]) {
			if(typeof(obj[i][j]) == 'object') {
				for(let k in obj[i][j]) {
					try {
						obj[i][j][k] = obj[i][j][k].replace(/%0a/g, '');
						obj[i][j][k] = decodeURIComponent(obj[i][j][k]);
					} catch(e) {
						console.log(e)
					}
				}
			} else {
				try {
					obj[i][j] = obj[i][j].replace(/%0a/g, '');
					obj[i][j] = decodeURIComponent(obj[i][j]);
				} catch(e) {
					console.log(e)
				}
			}
		}
	}
}

window.jiema_x = function(item) {
	let cc = window.Panduanxx(item);
	if(cc == 'array') {
		for(let i = 0; i < item.length; i++) {
			item[i] = window.jiema_x(item[i]);
		}
	} else if(cc == 'json') {
		for(let i in item) {
			item[i] = window.jiema_x(item[i]);
		}
	} else {
		// item = item.replace(/%0a/g, '');
		try {
			item = decodeURIComponent(item);
		} catch(e) {}

	}
	return item;
}

//判断对象类型
window.Panduanxx = function(param) {
	let dd = Object.prototype.toString.call(param);
	switch(dd) {
		case '[object String]':
			return 'string'
			break;
		case '[object Number]':
			return 'number'
			break;
		case '[object Boolean]':
			return 'boolean'
			break;
		case '[object Array]':
			return 'array'
			break;
		case '[object Object]':
			return 'json'
			break;
		case '[object Function]':
			return 'function'
			break;
		case '[object Null]':
			return 'null'
			break;
		case '[object Undefined]':
			return 'undefined'
			break;
		case '[object Date]':
			return 'date'
			break;
		case '[object RegExp]':
			return 'RegExp'
			break;
		default:
			break;
	}
}
//*************************************vue对象深度复制****************************//
window.Shendufuzhi = function(item) {
	let leixing = window.Panduanxx(item);
	let Tidai = null;
	if(leixing == 'json') {
		let str = JSON.stringify(item);
		str = JSON.parse(str);
		Tidai = str;
	} else {
		let jsona = {};
		jsona.item = item;
		let str = JSON.stringify(jsona);
		str = JSON.parse(str);
		Tidai = str.item;
	}
	return Tidai;
}

//*************************************获取菜单 url****************************//
window.caidanurl = function(str) {
	let url = "/appsearch_diy.aspx?t=caidanguanli&type=search_diy&sqlvalue=classid=" + str + "&number=9999&orderby=desc&ordertype=paixu";
	return url;
}

//*************************************提醒方式****************************//
window.txfs = function(str) {
	var patt0 = new RegExp("分钟");
	var patt1 = new RegExp("小时");
	var patt2 = new RegExp("天");
	let end = {};
	if(patt0.test(str)) {
		let str_ls = str.split('分钟');
		end = {
			"shijian": str_ls[0],
			"danwei": "分",
			"type": window.from_qh(str_ls[2]),
		};
	} else if(patt1.test(str)) {
		let str_ls = str.split('小时');
		end = {
			"shijian": str_ls[0],
			"danwei": "时",
			"type": window.from_qh(str_ls[2]),
		};
	} else if(patt2.test(str)) {
		let str_ls = str.split('天');
		end = {
			"shijian": str_ls[0],
			"danwei": "天",
			"type": window.from_qh(str_ls[2]),
		};
	}
	return end;
}
window.from_qh = function(str) {
	var patt0 = new RegExp("前");
	var patt1 = new RegExp("后");
	let str_ls = "";
	if(patt0.test(str)) {
		str_ls = "提前";
	} else if(patt1.test(str)) {
		str_ls = "延后";
	}
	return str_ls;
}
//*************************************数据提交对象****************************//
window.from_str = function(item) {
	let string = '';
	for(let i in item) {
		if(item[i] != '') {
			let str_ls = '&' + i + '=' + escape(item[i]);
			if(string == '') {
				string = str_ls;
			} else {
				string = string + str_ls;
			}
		}
	};
	return string;
}
window.from_str_ed1 = function(str1, str2, str) {
	let str_ls = "";
	if(str != '' && str) {
		let arr = str.split('&');
		if(arr.length > 0) {
			for(let j = 0; j < arr.length; j++) {
				if(arr[j] != "") {
					let arr_in = arr[j].split('=');
					if(arr_in[0] == str1) {
						str_ls = '&' + str1 + '=' + escape(arr_in[1]);
					} else {
						str_ls = '&' + str1 + '=' + escape(str2);
					}
				} else {
					str_ls = '&' + str1 + '=' + escape(str2);
				}
			}
		}
	} else {
		str_ls = '&' + str1 + '=' + escape(str2);
	}
	return str_ls;
}
window.from_str_vs1 = function(item, str) {
	let string = '';
	for(let i in item) {
		if(i == 'jsr' && item[i] != '') {
			let str_ls = "&yuangong=" + 　item[i];
			if(string == '') {
				string = str_ls;
			} else {
				string = string + str_ls;
			}
		}
		//      else if(i=='id'){
		//          
		//      }
		else {
			if(item[i] != '') {
				let str_ls = window.from_str_ed1(i, item[i], str);
				if(string == '') {
					string = str_ls;
				} else {
					string = string + str_ls;
				}
			}
		}
	};
	return string;
}
//*************************************金额绝对值****************************//
window.jine = function(jtem, str) {
	for(let j = 0; j < jtem.length; j++) {
		let item = jtem[j];
		for(let i in item) {
			for(let n = 0; n < str.length; n++) {
				if(i == str[n].biaoti) {
					item[i] = Math.abs(item[i]);
				}
			}
		};
	}
	return jtem;
}
//*************************************in id str****************************//
window.in_id_str = function(str0, str1, type) {
	if(str0 == '') {
		str0 = str1;
	} else {
		let arr = str0.split(type);
		let count = 0;
		for(let i = 0; i < arr.length; i++) {
			if(arr[i] == str1) {
				count++;
			}
		}
		if(count == 0) {
			str0 = str0 + type + str1;
		}
	}
	return str0;
}
//*************************************not in id str****************************//
window.not_in_id_str = function(str0, str1, type) {
	let str2 = "";
	if(str0 != '') {
		let arr = str0.split(type);
		for(let i = 0; i < arr.length; i++) {
			if(arr[i] != str1) {
				if(str2 == '') {
					str2 = arr[i];
				} else {
					str2 = str2 + type + arr[i];
				}
			}
		}
	}
	return str2;
}

//*************************************  文件下载  ****************************//
window.downloadFile = function(sUrl) {

	//iOS devices do not support downloading. We have to inform user about this.
	if(/(iP)/g.test(navigator.userAgent)) {
		alert('Your device does not support files downloading. Please try again in desktop browser.');
		return false;
	}

	//If in Chrome or Safari - download via virtual link click
	if(window.downloadFile.isChrome || window.downloadFile.isSafari) {
		//Creating new link node.
		var link = document.createElement('a');
		link.href = sUrl;

		if(link.download !== undefined) {
			//Set HTML5 download attribute. This will prevent file from opening if supported.
			var fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
			link.download = fileName;

		}

		//Dispatching click event.
		if(document.createEvent) {
			var e = document.createEvent('MouseEvents');
			e.initEvent('click', true, true);
			link.dispatchEvent(e);
			return true;
		}
	}

	// Force file download (whether supported by server).
	if(sUrl.indexOf('?') === -1) {
		sUrl += '?download';
	}

	// window.open(sUrl, '_self');
	window.open(sUrl);
	return true;
}

//

//*************************************  模型参数  ****************************//
window.mxcs = function(str) {
	let endstr = "";
	if(str == 'rc') {
		endstr = '人才';
	} else if(str == 'qy') {
		endstr = '企业';
	} else if(str == 'zsdd') {
		endstr = '证书订单';
	} else if(str == 'zzdd') {
		endstr = '资质订单';
	} else if(str == 'fwdd') {
		endstr = '服务订单';
	}
	return endstr;
}

window.mxcs_act = function(item) {
	let endstr = "";
	if(item.str == 'rc') {
		if(item.type == 'string') {
			endstr = '人才';
		} else if(item.type == 't') {
			endstr = 'rencai';
		}
	} else if(item.str == 'qy') {
		if(item.type == 'string') {
			endstr = '企业';
		} else if(item.type == 't') {
			endstr = 'qiye';
		}
	} else if(item.str == 'zsdd') {
		if(item.type == 'string') {
			endstr = '证书订单';
		} else if(item.type == 't') {
			endstr = 'zhengshudingdan';
		}
	} else if(item.str == 'zzdd') {
		if(item.type == 'string') {
			endstr = '资质订单';
		} else if(item.type == 't') {
			endstr = 'zizhidingdan';
		}
	} else if(item.str == 'fwdd') {
		if(item.type == 'string') {
			endstr = '服务订单';
		} else if(item.type == 't') {
			endstr = 'fuwudingdan';
		}
	}
	return endstr;
}

//************************************* $我是分隔符$ ****************************//
window.dx_str = function(item) {
	let str = '';
	if(item.length != 0) {
		for(let i = 0; i < item.length; i++) {
			if(str == '') {
				str = item[i];
			} else {
				str = str + '$我是分隔符$' + item[i];
			}
		}
	}
	return str;
}

//************************************* 换行符拆分 ****************************//
window.huanhangfu = function(item) {
	if(item.indexOf('\r\n') > 0) {
		let run = item.split('\r\n');
		return run;
	}
	if(item.indexOf('\n') > 0) {
		let run = item.split('\n');
		return run;
	}
	if(item.indexOf('\r') > 0) {
		let run = item.split('\r');
		return run;
	}
}

//************************************* 证书级别 info ****************************//
window.zsjb_info = function(item) {
	let dtem = [];
	for(let i in item) {
		let four = item[i];
		let tt_c = {
			jb: item[i].jibie,
			zy: item[i].zhuanye,
			zc: item[i].chu_zhuan,
			sl: item[i].shuliang,
			fs: item[i].fenshu,
			id: item[i].id,
			sanleirenyuan: four.sanleirenyuan,
			zhicheng: four.zhicheng,
			yongtu: four.yongtu,
			shebaoxinxi: four.shebaoxinxi,
			jiage: four.jiage,
			nian: four.nian,
			daizhuanye: four.daizhuanye,
			xuanz: false,
		};
		dtem.push(tt_c);
	};
	return dtem;
}

//************************************* 证书级别 text ****************************//
window.zsjb_text = function(item) {
	let zhengshujibie = "";
	if(item.length != 0) {
		for(let i in item) {
			if(item[i] != '') {
				let ls_jibie = item[i].jb + "，" + item[i].zy + "，" + item[i].zc;
				if(zhengshujibie == '') {
					zhengshujibie = ls_jibie;
				} else {
					zhengshujibie = zhengshujibie + "；" + ls_jibie;
				}
			}
		}
	}
	return zhengshujibie;
}

//************************************* 当前日期 ****************************//
window.Dangqianriqi = function() {
	var date = new Date();
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if(month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if(strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}

//************************************* 日期处理 ****************************//
window.riqichuli = function(item) {
	var date = new Date(item);
	var seperator1 = "-";
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	if(month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if(strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	var currentdate = year + seperator1 + month + seperator1 + strDate;
	return currentdate;
}

//************************************* 获取日期 ****************************//
window.Huoquriqi = function(item) {
	let day = 24 * 60 * 60 * 1000;
	let dangqian = new Date();
	let shu = dangqian.getTime();
	//今天
	dangqian = window.riqichuli(dangqian);

	//昨天
	let zuotian = new Date(shu - day);
	zuotian = window.riqichuli(zuotian);

	//本周
	let dang = new Date();
	let zhou = dang.getUTCDay(0);
	let benzhou = new Date(shu - day * (zhou - 1));
	benzhou = window.riqichuli(benzhou);

	//上周
	let shangzhoustar = new Date(shu - day * (zhou - 1 + 7));
	shangzhoustar = window.riqichuli(shangzhoustar);
	let shangzhouend = new Date(shu - day * (zhou));
	shangzhouend = window.riqichuli(shangzhouend);

	//前7天
	let qitian = new Date(shu - day * 7);
	qitian = window.riqichuli(shangzhouend);

	//本月
	let benyue = new Date();
	benyue.setDate(1);
	benyue = window.riqichuli(benyue);

	//上月
	let nowdays = new Date();
	let year = nowdays.getFullYear();
	let month = nowdays.getMonth();
	if(month == 0) {
		month = 12;
		year = year - 1;
	}
	if(month < 10) {
		month = "0" + month;
	}
	let shangyuestar = year + "-" + month + "-" + "01";
	let myDate = new Date(year, month, 0);
	let shangyueend = year + "-" + month + "-" + myDate.getDate(); //上个月的最后一天 

	let alltime = [{
			biaoti: '今天',
			time: dangqian + 'BETWEEN' + dangqian,
		},
		{
			biaoti: '昨天',
			time: zuotian + 'BETWEEN' + zuotian,
		},
		{
			biaoti: '本周',
			time: benzhou + 'BETWEEN' + dangqian,
		},
		{
			biaoti: '上周',
			time: shangzhoustar + 'BETWEEN' + shangzhouend,
		},
		{
			biaoti: '前七天',
			time: qitian + 'BETWEEN' + dangqian,
		},
		{
			biaoti: '本月',
			time: benyue + 'BETWEEN' + dangqian,
		},
		{
			biaoti: '上月',
			time: shangyuestar + 'BETWEEN' + shangyueend,
		},
	];
	if(item && item != '') {
		switch(item) {
			case '今天':
				return dangqian + 'BETWEEN' + dangqian;
				break;
			case '昨天':
				return zuotian + 'BETWEEN' + zuotian;
				break;
			case '本周':
				return benzhou + 'BETWEEN' + dangqian;
				break;
			case '上周':
				return shangzhoustar + 'BETWEEN' + shangzhouend;
				break;
			case '前七天':
				return qitian + 'BETWEEN' + dangqian;
				break;
			case '本月':
				return benyue + 'BETWEEN' + dangqian;
				break;
			case '上月':
				return shangyuestar + 'BETWEEN' + shangyueend;
				break;
			default:
				break;
		}
	} else {
		return alltime;
	}

}

//************************************* 判断string格式 ****************************//
window.Panduangeshi = function(str) {
	let geshi = '字符串';
	let shuzi = /^[0-9]*$/;
	if(shuzi.test(str)) {
		return '数字';
	}
	let riqi = /^(\d{4})-(\d{2})-(\d{2})$/;
	if(riqi.test(str)) {
		return '日期';
	}
	return geshi;
}

//************************************* 数据类型判断 ****************************//
window.Shujupanduan = function(item) {
	switch(item) {
		case '标题':
			return '字符串';
			break;
		case '货币':
			return '数字';
			break;
		case '多选下拉框':
			return '字符串';
			break;
		case '组图':
			return '字符串';
			break;
		case '时间框':
			return '日期';
			break;
		case '密码框':
			return '字符串';
			break;
		case '数字':
			return '数字';
			break;
		case '多选按钮组':
			return '字符串';
			break;
		case '单选按钮组':
			return '字符串';
			break;
		case '下拉框':
			return '字符串';
			break;
		case '文件框':
			return '字符串';
			break;
		case '文本域':
			return '字符串';
			break;
		case '文本框':
			return '字符串';
			break;
		default:
			break;
	}
}

//************************************* 搜索类型循环 ****************************//
window.Sousuoxunhuan = function(item, neirong) {
	let geshiz = window.Panduangeshi(neirong);
	// item 表头
	let sousuo = '';
	if(item.length > 0) {
		for(let i = 0; i < item.length; i++) {
			if(item[i].u10 == '是' && item[i].u1 != 'shanchuzhuangtai') {
				let leixing = window.Shujupanduan(item[i].u6);
				if(leixing == '字符串' && geshiz == '字符串' || geshiz == '数字') {
					if(sousuo == '') {
						sousuo += item[i].u1 + "{like}'{bfb}" + neirong + "{bfb}'";
					} else {
						sousuo += "/" + item[i].u1 + "{like}'{bfb}" + neirong + "{bfb}'";
					}
				}
				if(leixing == '数字' && geshiz == '数字') {
					if(sousuo == '') {
						sousuo += item[i].u1 + "=" + neirong;
					} else {
						sousuo += "/" + item[i].u1 + "=" + neirong;
					}

				}
				if(leixing == '日期' && geshiz == '日期') {
					if(sousuo == '') {
						sousuo += item[i].u1 + "=" + neirong;
					} else {
						sousuo += "/" + item[i].u1 + "=" + neirong;
					}

				}
			}
		}
	}
	return sousuo;
}

//************************************* 列表 数据 表头 数据处理 ****************************//
window.Liebiaolistchuli = function(biaotou, list) {
	let all = null;
	for(let i = 0; i < list.length; i++) {
		for(let j in list[i]) {
			let leixing = window.Biaotouchuli(biaotou, j);
			if(leixing != null) {
				if(leixing.u6 == '多选按钮组') {
					console.log(list[i][j].indexOf('$我是分隔符$'))
					if(list[i][j].indexOf('$我是分隔符$') > 0) {
						console.log(list[i][j])
						list[i][j] = list[i][j].replace(/$我是分隔符$/g, "");
					}
				}
				if(leixing.u6 == '组图') {
					list[i][j] = list[i][j].split('{next}');
					for(let k = 0; k < list[i][j].length; k++) {
						list[i][j][k] = list[i][j][k].split('{title}');
					}
				}
				if(leixing.u6 == '数字' && leixing.u8 != "0") {
					let bl = false;
					for(let k in list[i][j]) {
						if(k != 'jigou' && k != 'zhi' && !bl) {
							list[i][j] = list[i][j][k];
						}
					}
				}
			}
		}
	}
}
window.Biaotouchuli = function(biaotou, item) {
	let c = null;
	for(let i = 0; i < biaotou.length; i++) {
		if(biaotou[i].u1 == item) {
			c = biaotou[i];
		}
	}
	return c;
}
//************************************* 列表 数据 表头 数据处理 ****************************//

//************************************* for in return ****************************//
window.Forinreturn = function(key, item) {
	for(let i in item) {
		if(i == key) {
			return item[i];
		}
	}
}

//************************************* 树形结构 数据搜索 处理****************************//
window.Shuxingsousuo = function(key, item, str) {
	let lx = window.Panduanxx(item);
	if(lx == 'array') {
		for(let i = 0; i < item.length; i++) {
			let c = window.Shuxingsousuo(key, item[i], str);
			if(c) {
				return c;
			}
		}
	} else if(lx == 'json') {
		if(item.id == key) {
			return item;
		} else {
			let t = eval('item.' + str);
			if(t) {
				let c = window.Shuxingsousuo(key, t, str);
				if(c) {
					return c;
				}
			}
		}
	}
}
//************************************* 树形结构 数据搜索 处理****************************//

//*************************************  local数据 转码 处理  ****************************//
window.Localzhuan = function(str, item) {
	let mm = '';
	mm = escape(item);
	localStorage.setItem(str, mm);
}
window.Localjie = function(str) {
	let mm = localStorage.getItem(str);
	mm = unescape(mm);
	return mm;
}
//*************************************  local数据 转码 处理  ****************************//

//*************************************  数据格式 转换  ****************************//
window.Geshizhuanhuan = function(item) {
	for(let i = 0; i < item.length; i++) {
		for(let j in item[i]) {
			let type = window.Panduanxx(item[i][j]);
			if(type == 'json') {
				let str = '';
				for(let k in item[i][j]) {
					if(k != 'zhi') {
						if(str == '') {
							str = item[i][j][k];
						} else {
							str = str + "," + item[i][j][k];
						}
					} else {
						let c = j + 'zhi';
						item[i][c] = item[i][j][k];
					}
				}
				item[i][j] = str;
			}
		}
	}
	return item;
}
//*************************************  数据格式 转换   ****************************//

//*************************************  子菜单 判断   ****************************//
window.Caidancaifen = function(item, value) {
	for(let i = 0; i < item.length; i++) {
		if(item[i].id == value) {
			if(item[i].children) {
				return item[i].children;
			} else {
				return [];
			}
		} else {
			if(item[i].children) {
				let c = window.Caidancaifen(item[i].children, value);
				if(c) {
					return c;
				}
			}
		}
	}
}
//*************************************  子菜单 判断   ****************************//

//*************************************  银行卡号验证 start   ****************************//
window.CheckBankNo = function(bankno) {
	var bankno = bankno.replace(/\s/g, '');
	if(bankno == "") {
		let c = [false, "请填写银行卡号"]
		return c;
	}
	if(bankno.length < 16 || bankno.length > 19) {
		let c = [false, "银行卡号长度必须在16到19之间"]
		return c;
	}
	var num = /^\d*$/; //全数字
	if(!num.exec(bankno)) {
		let c = [false, "银行卡号必须全为数字"]
		return c;
	}
	//开头6位
	var strBin = "10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";
	if(strBin.indexOf(bankno.substring(0, 2)) == -1) {
		let c = [false, "银行卡号开头6位不符合规范"]
		return c;
	}
	//Luhn校验
	if(!window.luhnCheck(bankno)) {
		let c = [false, "未通过验证"];
		return c;
	}
	let c = [true, "通过验证"];
	return c;
}

window.luhnCheck = function(bankno) {
	var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhn进行比较）

	var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
	var newArr = new Array();
	for(var i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
		newArr.push(first15Num.substr(i, 1));
	}
	var arrJiShu = new Array(); //奇数位*2的积 <9
	var arrJiShu2 = new Array(); //奇数位*2的积 >9

	var arrOuShu = new Array(); //偶数位数组
	for(var j = 0; j < newArr.length; j++) {
		if((j + 1) % 2 == 1) { //奇数位
			if(parseInt(newArr[j]) * 2 < 9)
				arrJiShu.push(parseInt(newArr[j]) * 2);
			else
				arrJiShu2.push(parseInt(newArr[j]) * 2);
		} else //偶数位
			arrOuShu.push(newArr[j]);
	}

	var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
	var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
	for(var h = 0; h < arrJiShu2.length; h++) {
		jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
		jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
	}

	var sumJiShu = 0; //奇数位*2 < 9 的数组之和
	var sumOuShu = 0; //偶数位数组之和
	var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
	var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
	var sumTotal = 0;
	for(var m = 0; m < arrJiShu.length; m++) {
		sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
	}

	for(var n = 0; n < arrOuShu.length; n++) {
		sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
	}

	for(var p = 0; p < jishu_child1.length; p++) {
		sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
		sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
	}
	//计算总和
	sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

	//计算luhn值
	var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
	var luhn = 10 - k;

	if(lastNum == luhn) {
		console.log("验证通过");
		return true;
	} else {
		console.log("银行卡号必须符合luhn校验");
		return false;
	}
}
//*************************************  银行卡号验证 end   ****************************//

//*************************************  location_href   ****************************//
window.location_href = function(type) {
	let href = location.protocol + '//' + location.hostname;
	if(location.port != '') {
		href = href + ":" + location.port;
	}
	if(type == '1') {
		if(location.hostname != 'localhost' && location.hostname != '192.168.0.227') {
			href = href + '/crm/zhengshu';
		}
	}
	if(type == '3') {
		href = window.getCookie('url_zong');
	}
	return href;
}

//*************************************  组图转换   ****************************//
/*
 * [{"status":"finished","name":"d.jpg","size":38930,"percentage":100,"uid":1522289514937,"showProgress":true,"response":{"url":"/upfile/Upload/2018329/2018329101218199.jpg","filename":"2018329101218199.jpg"},"url":"https://new.5g.com.cn:81/upfile/Upload/2018329/2018329101218199.jpg"},{"status":"uploading","name":"w.jpg","size":53002,"percentage":100,"uid":1522289514944,"showProgress":true}]
 */
window.zutu_chuli = function(item) {
	let zutu = "";
	if(item.length > 0) {
		for(let i = 0; i < item.length; i++) {
			if(item[i].status == 'finished') {
				let zutu_ls = item[i].response.url + "{title}" + item[i].name;
				if(zutu == "") {
					zutu = zutu_ls;
				} else {
					zutu = zutu + "{next}" + zutu_ls;
				}
			}
		}
	}
	return zutu;
}

//

window.IdCard = function(UUserCard, num) {
	if(num == 1) {
		//获取出生日期
		var birth = UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
		return birth;
	}
	if(num == 2) {
		//获取性别
		if(parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
			//男
			return "男";
		} else {
			//女
			return "女";
		}
	}
	if(num == 3) {
		//获取年龄
		var myDate = new Date();
		var month = myDate.getMonth() + 1;
		var day = myDate.getDate();
		var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
		if(UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
			age++;
		}
		return age;
	}
}

//*************************************  获取 几天后时间   ****************************//

window.huoquhoushijian = function(day, hour, min) {
	const date = new Date();
	let riqi = new Date();
	let shu = parseInt(date.getTime(date)) + 1000 * 60 * 60 * 24 * parseInt(day);
	riqi.setTime(shu);
	riqi.setHours(hour);
	riqi.setMinutes(min);
	riqi.setSeconds(0);
	return riqi;
}

//*************************************  获取 几天后时间   ****************************//

//*************************************  数据比对   ****************************//
//original 原数据  target 新数据  keys 对比 key
window.Shujubidui = function(original, target, keys) {
	let repeat = []; // 重复数据
	let newshuju = []; // 新数据
	let delshuju = []; // 消失数据
	original.forEach(e => {
		let del = true;
		target.forEach(v => {
			let bi = keys.split(',');
			let pan = true;
			for(let i = 0; i < bi.length; i++) {
				if(bi[i] && bi[i] != '') {
					let key = bi[i];
					if(e[key] != v[key]) {
						pan = false;
					}
				}
			}
			if(pan) {
				repeat.push(e);
				del = false; // del 数据判断
			}
			return v;
		})
		if(del) {
			delshuju.push(e);
		}
		return e;
	})
	target.forEach(e => {
		let pan = true;
		original.forEach(v => {
			let bi = keys.split(',');
			let z = true;
			for(let i = 0; i < bi.length; i++) {
				if(bi[i] && bi[i] != '') {
					let key = bi[i];
					if(e[key] != v[key]) {
						z = false;
					}
				}
			}

			if(z) {
				pan = false;
				return false;
			}
			return v;
		})
		if(pan) {
			newshuju.push(e);
		}
		return e;
	})
	let back = {
		'repeat': repeat,
		'newshuju': newshuju,
		'delshuju': delshuju,
	}
	return back;
}

//*************************************  数据比对   ****************************//

//*************************************  机构级联选择   ****************************//
window.jigou_jlxz = function(jigou_list) {
	let item = [];
	if(jigou_list != undefined) {
		if(jigou_list.length > 0) {
			for(let k = 0; k < jigou_list.length; k++) {
				let ktem = {
					value: jigou_list[k].id,
					label: jigou_list[k].jigoumingcheng,
					children: window.jigou_jlxz(jigou_list[k].children),
				};
				item.push(ktem);
			}
		}
	}
	return item;
}

//*************************************  机构级联选择   ****************************//

//*************************************  层级递归处理   ****************************//
window.Diguichuli = function(item, str, key) {
	let lx = window.Panduanxx(item);
	let restr = '';
	if(lx == 'array') {
		item.forEach(element => {
			if(element[key] && element[key] != '') {
				restr += element[key] + "{or}";
			}
			if(element[str]) {
				let c = window.Diguichuli(element[str], str, key);
				restr += c;
			}
			return element;
		});
	} else if(lx == 'json') {
		if(item[key] && item[key] != '') {
			restr += item[key] + "{or}";
		}
		if(item[str]) {
			let c = window.Diguichuli(item[str], str, key);
			restr += c;
		}
	}
	return restr;
}


// WEBPACK FOOTER //
// ./src/js/common.js